import React, { useState } from 'react';
import data from '../../services.json';

const { faq } = data;

const FAQ = () => {
  const { id, heading, items, footer } = faq;
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section
      id={id}
      className="w-full ava-card-bg"
      
    >
      <div className="container mx-auto px-4 md:px-8">
        <div
          className="rounded-2xl px-6 ava-section-gap md:px-12  max-w-4xl mx-auto"
          // style={{ backgroundColor: 'var(--gray-100)' }}
        >

          {/* ── Heading ── */}
          <h2
            className="text-center ava-heading-lg ava-heading-gap"
            style={{
              // color: 'var(--primary-color)',
              // fontSize: 'clamp(1.3rem, 2.8vw, 2rem)',
            }}
          >
            {heading}
          </h2>

          {/* ── Accordion items ── */}
          <div className="flex flex-col gap-3">
            {items.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className="rounded-xl overflow-hidden"
                  style={{
                    backgroundColor: '#fff',
                    boxShadow: '0 1px 8px rgba(0,36,107,0.06)',
                  }}
                >
                  {/* Question row */}
                  <button
                    onClick={() => toggle(item.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between px-6 py-5 text-left transition-colors duration-200"
                    style={{
                      backgroundColor: isOpen ? 'var(--ava-card-bg)' : '#fff',
                    }}
                  >
                    <span
                      className="ava-text-subheading pr-4"
                      // style={{ color: 'var(--primary-color)' }}
                    >
                      {item.question}
                    </span>

                    {/* + / × icon */}
                    <span
                      className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-md transition-transform duration-300"
                      style={{
                        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ color: 'var(--primary-color)' }}
                      >
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </span>
                  </button>

                  {/* Answer panel — smooth height transition */}
                  <div
                    className="overflow-hidden transition-all duration-300 ease-in-out"
                    style={{
                      maxHeight: isOpen ? '500px' : '0px',
                      opacity: isOpen ? 1 : 0,
                    }}
                  >
                    <p
                      className="px-6 pb-5 pt-2 ava-text-body "
                    >
                      {item.answer}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ── Footer CTA ── */}
          {footer && (
            <div className="flex flex-col items-center gap-4 mt-10 ">
              <p
                className=" ava-text-subheading "
              >
                {footer.text}
              </p>
              <a
                href={footer.cta.href}
                className="btn-transparent"
                style={{
                  // color: 'var(--primary-color)',
                  // borderColor: 'var(--primary-color)',
                  // backgroundColor: 'transparent',
                }}
              >
                {footer.cta.label}
              </a>
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default FAQ;